import { useMemo } from 'react'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import {
    editItineraryFieldsTranslation,
    editItineraryTranslation,
} from '../../../i18n/translateHelpers'
import { FormEditMembers } from '../formComponents/formEditMembers'
import { FormText } from '../formComponents/formText'
import { PremiumFormUploadDocs } from '../formComponents/formUploadDocs'
import { BaseBookingItemPage } from '../subPages/baseBookingItemPage'
import { ActivityValidationSchema } from './activityEditItem'

export const ActivityBookingItemPage = () => {
    const { idBooking } = useParams<{ idBooking: string }>()
    const { watch, control, setValue, resetField, getValues } =
        useFormContext<ActivityValidationSchema>()
    const { dirtyFields } = useFormState({ control })

    const name = watch('activity_name') || ''
    const attendeesList =
        useWatch<ActivityValidationSchema>({
            control,
            name: 'attendees_list',
        }) || []
    const attendeeIndex = useMemo(() => {
        if (!attendeesList || !Array.isArray(attendeesList)) return 0
        const index = attendeesList.findIndex(
            (attendee) => attendee?._id === idBooking
        )
        return index >= 0 ? index : 0
    }, [attendeesList, idBooking])

    const isDirty = dirtyFields?.attendees_list?.[attendeeIndex] ? true : false
    const reset = () => {
        resetField(`attendees_list.${attendeeIndex}`)
        const v = getValues(`attendees_list.${attendeeIndex}`)
        if (!v) {
            const all = getValues(`attendees_list`)
            const newList = all.filter(
                (_: any, index: number) => index !== attendeeIndex
            )
            setValue('attendees_list', newList)
        }
    }
    const onSaveData = () => {
        resetField(`attendees_list.${attendeeIndex}`, {
            defaultValue: {
                ...attendeesList[attendeeIndex],
            },
            keepDirty: true,
        })
    }
    return (
        <BaseBookingItemPage
            onReset={reset}
            onSaveData={onSaveData}
            isDirty={isDirty}
            deleteAction={() => {
                const newList = attendeesList.filter(
                    (_: any, index: number) => index !== attendeeIndex
                )
                setValue('attendees_list', newList, { shouldDirty: true })
            }}
            key={attendeeIndex}
            headerText={editItineraryTranslation('Edit Booking')}
            subHeaderText={name}
        >
            <FormText
                fieldLabel={editItineraryFieldsTranslation(
                    'Personal Information'
                )}
                control={control as any}
                name={`attendees_list.${attendeeIndex}.notes`}
                multiline
                rows={2}
            />
            <PremiumFormUploadDocs
                fieldLabel={editItineraryFieldsTranslation('Documents')}
                control={control}
                name={`attendees_list.${attendeeIndex}.documents`}
            />
            <FormEditMembers
                control={control}
                name={`attendees_list.${attendeeIndex}.users`}
            />
        </BaseBookingItemPage>
    )
}
